// AGC: Revenue Summary Dashboard Widget
// AGC: Shows quick overview of revenue stats on Home page

import React from 'react'
import { TrendingUp, ArrowRight, DollarSign, Calendar } from 'lucide-react'
import { useRevenues } from '../../hooks/useRevenues'

interface RevenueSummaryProps {
  onViewDetails: () => void
}

export const RevenueSummary: React.FC<RevenueSummaryProps> = ({ onViewDetails }) => {
  // AGC: Fetch real revenue data from StakingRevenueShare contract
  const { stats } = useRevenues()

  // AGC: Format currency helper
  const formatCurrency = (value: number) => {
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD',
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }).format(value)
  }

  return (
    <div className="bg-slate-800/50 rounded-xl p-5 border border-slate-700/50 h-full">
      <div className="flex items-center justify-between mb-4">
        <h3 className="text-white font-semibold flex items-center gap-2">
          <TrendingUp className="w-5 h-5 text-[#0072CE]" />
          Revenue Overview
        </h3>
        <button
          onClick={onViewDetails}
          className="text-xs text-[#0072CE] hover:text-[#0088e6] flex items-center gap-1"
        >
          View Details <ArrowRight className="w-3 h-3" />
        </button>
      </div>

      <div className="space-y-3">
        <div className="flex items-center justify-between">
          <span className="text-slate-400 text-sm">Total Revenue</span>
          <span className="text-white font-semibold flex items-center gap-1">
            <DollarSign className="w-3 h-3 text-slate-500" />
            {formatCurrency(stats.totalRevenue)}
          </span>
        </div>
        <div className="flex items-center justify-between">
          <span className="text-slate-400 text-sm">Stakers Share (50%)</span>
          <span className="text-[#0072CE] font-semibold">{formatCurrency(stats.stakersShare)}</span>
        </div>
        <div className="flex items-center justify-between">
          <span className="text-slate-400 text-sm">This Week</span>
          <span className="text-white font-semibold flex items-center gap-1">
            <Calendar className="w-3 h-3 text-slate-500" />
            {formatCurrency(stats.thisMonth)}
          </span>
        </div>
      </div>

      <div className="mt-4 pt-4 border-t border-slate-700/50">
        <div className="flex items-center justify-between text-xs">
          <span className="text-slate-500">Active Projects</span>
          <span className="text-white font-medium">{stats.projects.length}</span>
        </div>
      </div>
    </div>
  )
}

